import * as React from "react";

export const IconLegalDocs = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="24" height="24" viewBox="16 8 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M23 25H25V20H23V25ZM31 25H33V15H31V25ZM27 25H29V22H27V25ZM27 20H29V18H27V20ZM21 29C20.45 29 19.98 28.8 19.59 28.41C19.2 28.02 19 27.55 19 27V13C19 12.45 19.2 11.98 19.59 11.59C19.98 11.2 20.45 11 21 11H35C35.55 11 36.02 11.2 36.41 11.59C36.8 11.98 37 12.45 37 13V27C37 27.55 36.8 28.02 36.41 28.41C36.02 28.8 35.55 29 35 29H21Z"
      fill="currentColor"
    />
  </svg>
);
